/* cwc-component-autocomplete */
:host {
  /**
  * @prop --cwc-autocomplete-field-border-width - Border width of the complete field
  * @prop --cwc-autocomplete-field-border-style - Border style of the complete field
  * @prop --cwc-autocomplete-field-border-color - Border color of the complete field
  * @prop --cwc-autocomplete-icon-color - color of the icon
  * @prop --cwc-autocomplete-reset-color - color of the reset icon
  * @prop --cwc-autocomplete-suggestions-zindex - z-index of the suggestion list
  * @prop --cwc-autocomplete-suggestions-maxheight - max-height of the suggestion list
  * @prop --cwc-autocomplete-suggestions-background-color - background color of the suggestion list
  * @prop --cwc-autocomplete-suggestions-border-width - border width of the suggestion list
  * @prop --cwc-autocomplete-suggestions-border-style - border style of the suggestion list
  * @prop --cwc-autocomplete-suggestions-border-color - border color of the suggestion list
  * @prop --cwc-autocomplete-suggestions-boxshadow - box shadow of suggestion list
  * @prop --cwc-autocomplete-suggestions-item-hover-background - background of the hovered/selected item in suggestion list
  * @prop --cwc-autocomplete-disabled-background-color - background color of disabled element
   */

  display: block;
  position: relative;
  border-radius: var(--cwc-autocomplete-border-radius, 0);
  background-color: var(--cwc-autocomplete-field-background-color, inherit);
}

:host([disabled]) {
  background-color: var(--cwc-autocomplete-disabled-background-color, #c3c3c3);
}

cwc-component-autocomplete {
  &-input {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 0.5em;
    gap: 0.5em;
    border: var(--cwc-autocomplete-field-border-width, 2px) var(--cwc-autocomplete-field-border-style, solid)
      var(--cwc-autocomplete-field-border-color, #408fc8);

    slot[name='icon'] {
      display: flex;
      flex: 0 0 1.5em;
      align-items: center;
      justify-content: center;
      fill: currentColor;
      color: var(--cwc-autocomplete-icon-color, #408fc8);
    }

    slot[name='icon'] > *,
    ::slotted(*) {
      width: 1.1rem;
      margin: 0 0.3rem 0 0;
    }

    input {
      flex-grow: 1;
      flex-shrink: 1;
      width: 100%;
      margin: 0;
      padding: 0;

      border: 0;
      border-radius: 0;
      outline: none;
      background-color: transparent;
      font-family: inherit;

      // Safari and Chrome on iOS will zoom in if font size is smaller than 16px, do not override it internally
      font-size: 1em;

      -webkit-tap-highlight-color: transparent;
      appearance: none;

      &::-ms-clear {
        display: none;
      }
    }

    .reset {
      display: flex;
      flex: 0 0 1.5rem;
      align-items: center;
      justify-content: center;
      height: 100%;
      fill: currentColor;
      color: var(--cwc-autocomplete-reset-color, #c8c8c8);
      cursor: pointer;

      // stylelint-disable-next-line selector-max-compound-selectors
      slot > *,
      ::slotted(*) {
        width: 1.1rem;
      }
    }
  }

  &-suggestions {
    display: block;
    position: absolute;
    z-index: var(--cwc-autocomplete-suggestions-zindex, 100);
    width: 100%;

    max-height: var(--cwc-autocomplete-suggestions-maxheight, 200px);

    overflow: hidden;
    overflow-y: scroll;
    border: var(--cwc-autocomplete-suggestions-border, 0);
    background-color: var(--cwc-autocomplete-suggestions-background-color, #fff);
    box-shadow: var(--cwc-autocomplete-suggestions-boxshadow, 0 4px 8px rgba(0, 0, 0, 0.2));

    &-item {
      display: block;
      padding: 0.5em;
      font-size: 1em;

      &:hover,
      &.selected {
        animation: item-background-transition 0.15s linear;
        background-color: var(--cwc-autocomplete-suggestions-item-hover-background, #ececec);
        cursor: pointer;
      }
    }
  }
}

@keyframes item-background-transition {
  0% {
    background: transparent;
  }
}
